<template>
  <div style="background-color: #F6F6F6;padding-top: 64px;">
    <!-- 公司介绍 -->
    <div class="detaileds">
      <div class="detailed-left">
        <div class="enterpriseDetails-name">
          <img v-if="companyInfo.logoUrl!==''" :src="companyInfo.logoUrl" class="enterpriseDetails-name-img" alt="">
          <img v-if="companyInfo.logoUrl===''" src="../assets/ping.png" class="enterpriseDetails-name-img" alt="">
          <div class="enterpriseDetails-names">
            <div class="enterpriseDetails-names-txt">{{companyInfo.name}}</div>
             <div class="enterpriseDetails-names-tabel">
              <div>{{companyInfo.nature}}</div>
              <div>{{companyInfo.tradeName}}</div>
              <div>{{companyInfo.scale}}</div>
            </div>
          </div>
        </div>
        <!-- <div class="detaileds-tabel">
          <div v-for="(item,index) in companyInfo.tagList" :key="index">{{item.title}}</div>
          <div class="detaileds-tabel-span" style="padding: 0;border: 1px solid #C9C9C9;"><span></span><span></span><span style="margin-right: 6px;"></span></div>
        </div> -->
      </div>
      <div class="detaileds-right" style="display: flex;display: inline-flex;flex-direction: column;width: 24%">
        <div class="linkmanBoxs">
          <img src="../assets/locationImgbtn.png" alt="" style="height: 16px;">
          <div>{{companyInfo.address}}</div>
        </div>
        <div class="linkmanBoxs" v-if="companyInfo.linkMan!==''&&companyInfo.linkMan!==undefined&&companyInfo.linkPhone!==''&&companyInfo.linkPhone!==undefined">
          <img src="../assets/linkMan-phone.png" alt="">
          <div style="margin-right: 5px">{{companyInfo.linkMan}}:</div>
          <div>{{companyInfo.linkPhone}}</div>
        </div>
      </div>
    </div>
    <!-- 公司介绍 -->
    <div>
      <div class="blurb-change">
        <div class="blurb-change-one" @click="changes(1)">企业简介</div>
      </div>
      <div class="enterpriseDetails-screen" v-if="change==2">
        <div class="enterpriseDetails-screen-box">
          <el-dropdown @command="handleEducation" style="margin-left: 28px;margin-top: 16px;background-color: #F1F1F1;width: 125px;">
            <span class="el-dropdown-link">
              {{education}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in selectList[0].list" :key="index" :command="item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleExperience" style="margin-left: 28px;margin-top: 16px;background-color: #F1F1F1;width: 125px;">
            <span class="el-dropdown-link">
              {{experience}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in selectList[1].list" :key="index" :command="item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleSalarys" style="margin-left: 28px;margin-top: 16px;background-color: #F1F1F1;width: 125px;">
            <span class="el-dropdown-link">
              {{salarys}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in selectList[2].list" :key="index" :command="item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleJobcategory" style="margin-left: 28px;margin-top: 16px;background-color: #F1F1F1;width: 125px;">
            <span class="el-dropdown-link">
              {{jobcategory}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in selectList[3].list" :key="index" :command="item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 简介 -->
    <div v-if="change==1">
      <div class="blurb">
        <div class="blurb-title">
          <div class="blurb-title-left">
            <div>{{companyInfo.content}}</div>
            <!-- <div>查看更多</div> -->
            <div></div>
          </div>
          <div class="cycle" v-if="companyInfo.swiperList!==undefined&&companyInfo.swiperList.length > 0" @mouseenter="stop" @mouseleave="start" >
            <div class="content" :style="changePic">
              <div class="blurb-title-img" v-for="(item, index) in companyInfo.swiperList" :key="index">
                <img style="width:385px;height: 213px;" :src="item.imgUrl" />
              </div>
            </div>
          </div>
          <img class="blurb-title-img" v-else src="../assets/index4.png" alt="" />
        </div>
      </div>
      <!-- 热招职位 -->
      <div class="enterpriseDetails-hots">
        <div class="enterpriseDetails-hots-title">在招职位</div>
      </div>
      <div class="enterpriseDetails-jobs">
        <div class="enterpriseDetails-boxs" v-for="(item,index) in jobInfoList" :key="index" @click="jobDetails(item.id)">
          <div class="enterpriseDetails-boxs-title" style="margin-top: 0">
            <div class="enterpriseDetails-boxs-top">
              <div>{{item.name}}</div>
              <div>【{{item.address}}】</div>
            </div>
            <div class="enterpriseDetails-boxs-requirement">
<!--              <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-price-item">{{item.salary}}-{{item.salaryEnd}}/月</div>
              <div v-if="item.salary==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-price-item">{{item.salaryEnd}}元以下</div>
              <div v-if="item.salaryEnd==undefined&&item.salary!==undefined" class="enterpriseDetails-price-item">{{item.salary}}元以上</div>
              <div v-if="item.isSalary==2" class="enterpriseDetails-price-item">面议</div>-->
              <div v-if="item.salaryName!==undefined&&item.salaryName!==null" class="enterpriseDetails-price-item">{{item.salaryName}}</div>
              <div class="enterpriseDetails-workName">{{item.workName}}</div>
              <div class="enterpriseDetails-eduName">{{item.eduName}}</div>
            </div>
            <div class="enterpriseDetails-boxs-requirement-jobs">
<!--              <div class="enterpriseDetails-boxs-requirement-jobs-detail" @click.stop="collect(item.id,item.isCollection)" >-->
<!--                <img v-if="gather==false" src="../assets/jobcollect.png" />-->
<!--                <img v-if="gather==true" src="../assets/iscollect.png" />-->
<!--                <div>收藏</div>-->
<!--              </div>-->
              <div class="enterpriseDetails-boxs-requirement-jobs-details" v-if="Logintoken==null" @click.stop="enroll(item.id)">
                <img src="../assets/enroll.png" />
                <div>一键投递</div>
              </div>
              <div class="enterpriseDetails-boxs-requirement-jobs-details" v-if="Logintoken!=null&&item.isSignUp==2"  @click.stop="enroll(item.id)">
                <img src="../assets/enroll.png" />
                <div >一键投递</div>
              </div>
              <div class="enterpriseDetails-boxs-requirement-jobs-detail-signup " v-if="Logintoken!=null&&item.isSignUp==1"  >
                <img src="../assets/isEnroll.png" />
                <div>已投递</div>
              </div>
            </div>
          </div>
          <div class="enterpriseDetails-boxs-label">
            <div v-for="(items,indexs) in jobInfoList[index].tagList" :key="indexs" class="enterpriseDetails-boxs-label-welfare">{{items.title}}</div>
            <div style="font-size: 12px;color: #979797;line-height: 22px;text-align: right;margin-right: 14px;">发布时间：{{item.updateTime}}</div>
          </div>
        </div>
      </div>
      <!-- 热招职位 -->
    </div>
    <!-- 简介 -->

    <!-- 职位推荐 -->
<!--    <div class="enterpriseDetails-bottom" v-if="change==2">
      <div style="float: left;width: 100%;margin-right: 16px;">
        <div class="enterpriseDetails-joblist" v-for="(item,index) in jobInfoList" :key="index" @click="jobDetails(item.id)" style="width: 100%">
          <div class="enterpriseDetails-boxs-title">
            <div class="enterpriseDetails-boxs-top">
              <div>{{item.name}}</div>
              <div>【{{item.address3}}】</div>
            </div>
            <div class="enterpriseDetails-boxs-requirement">
              <div v-if="item.salaryName!==undefined&&item.salaryName!==null" class="enterpriseDetails-price-item">{{item.salaryName}}</div>
              <div class="enterpriseDetails-workName">{{item.workName}}</div>
              <div class="enterpriseDetails-eduName">{{item.eduName}}</div>
            </div>
            <div class="enterpriseDetails-boxs-requirement-jobs">
              <div class="enterpriseDetails-boxs-requirement-jobs-detail" @click.stop="collect()" >
                <img v-if="gather==false" src="../assets/jobcollect.png" />
                <img v-if="gather==true" src="../assets/iscollect.png" />
                <div>收藏</div>
              </div>
              <div class="enterpriseDetails-boxs-requirement-jobs-details" @click.stop="enroll(item.id)">
                <img src="../assets/enroll.png" />
                <div v-if="item.isSignUp==2">一键投递</div>
                <div v-if="item.isSignUp==1">已投递</div>
              </div>
            </div>
          </div>
          <div class="enterpriseDetails-boxs-label">
            <div v-for="(items,indexs) in jobInfoList[index].tagList" :key="indexs" class="enterpriseDetails-boxs-label-welfare">{{items.title}}</div>
            <div style="font-size: 12px;color: #979797;line-height: 22px;text-align: right;margin-right: 14px;">发布时间：{{item.updateTime}}</div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- 职位推荐 -->
  </div>
</template>

<script>

import request from '../util/request.js'

export default{
  data () {
    return {
      selectList: [],
      companyInfo: {},
      jobInfoList: [],
      change: 1,
      education: '学历',
      experience: '经验',
      salarys: '薪资范围',
      jobcategory: '职位类别',
      id: '',
      gather: false,
      islogin: false,
      url: '',
      randKey: '',
      num: 0,
      userInfo: {},
      isLogin: false,
      index: 0,
      time: 2000,
      width: 0,
      Logintoken: '',
      operation: ''
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
      this.Logintoken = localStorage.getItem('token')
    })
  },
  computed: {
    changePic () {
      return {
        transform: `translate3d(${this.width}px, 0, 0)`
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/companyDetail`,
        data: JSON.stringify({
          id: that.id
        })
      }).then(
        (res) => {
          that.selectList = res.data.data.selectList
          that.companyInfo = res.data.data.companyInfo
          that.jobInfoList = res.data.data.jobInfoList
        },
        (err) => {
          that.$message.error(err)
        }
      )
      var token = localStorage.getItem('token')
      if (token !== null) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user`,
          data: JSON.stringify({})
        }).then(
          (res) => {
            if (res.data.code === 200) {
              that.userInfo = res.data.data.userInfo
            }
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    jobDetails (id) {
      this.iscode = false
      this.$router.push({
        path: '/jobDetails',
        query: {
          id: id
        }
      })
    },
    stop () {
      clearInterval(this.timer)
    },
    start () {
      this.timer = setInterval(() => {
        this.go(-1)
      }, 2000)
    },
    go (direc) {
      if (direc === -1) {
        this.index = this.index >= this.companyInfo.swiperList.length - 1 ? 0 : this.index + 1
      } else if (direc === 1) {
        this.index = this.index <= 0 ? this.companyInfo.swiperList.length - 1 : this.index - 1
      }
      this.move()
    },
    move () {
      this.width = -385 * this.index
    },
    changes (e) {
      this.change = e
    },
    handleEducation (command) {
      this.education = command
    },
    handleExperience (command) {
      this.experience = command
    },
    handleSalarys (command) {
      this.salarys = command
    },
    collect (id, isCollection) {
      var that = this
      console.log(id)
      console.log(isCollection)
      var token = localStorage.getItem('token')
      if (token === null) {
        that.$message.error('请先登录!')
        this.$bus.emit('iscode', 'true')
        return false
      }
      if (that.userInfo.identity === 2) {
        that.$message.error('企业无法收藏岗位!')
        return false
      }
      if (isCollection === false) {
        that.operation = 1
      } else {
        that.operation = 2
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/addCollection`,
        data: JSON.stringify({
          id: id,
          operation: that.operation
        })
      }).then(
        (res) => {
          if (that.operation === 1) {
            that.$message.success('收藏成功！')
          } else {
            that.$message.success('取消收藏')
          }
          that.getData()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    enroll (id) {
      var that = this
      var token = localStorage.getItem('token')
      if (token === null) {
        that.$message.error('请先登录!')
        this.$bus.emit('iscode', 'true')
        return false
      }
      if (that.userInfo.identity === 2) {
        that.$message.error('企业无法投递!')
        return false
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/sigUp`,
        data: JSON.stringify({
          id: id,
          type: '2'
        })
      }).then(
        (res) => {
          if (res.data.data.isJobResume === false) { // 如果没有简历
            that.$confirm('请完善简历后投递', {
              confirmButtonText: '去填写',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({path: '/editResume'})
            }).catch(() => {})
          } else {
            that.$message.success('报名成功！')
            that.getData()
          }
        },
        (err) => {
          that.$message.success(err)
        }
      )
    },
    handleJobcategory (command) {
      this.jobcategory = command
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
/* 公司介绍 */
.detaileds {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
  margin-top: 21px;
}
.detailed-left {
  float: left;
  width: 60%;
}
.enterpriseDetails-name{
  overflow: hidden;
  margin-top: 33px;
  margin-left: 24px;
  margin-bottom: 22px;
}
.enterpriseDetails-name-img{
  float: left;
  margin-right: 12px;
  width: 62px;
  height: 62px;
}
.enterpriseDetails-names{
  float: left;
}
.enterpriseDetails-names-txt{
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 550;
}
.enterpriseDetails-names-tabel{
  overflow: hidden;
  font-size: 14px;
  color: #868686;
}
.enterpriseDetails-names-tabel div{
  float: left;
  margin-right: 47px;
}
.enterpriseDetails-names-tabel div:last-child{
  margin-right: 0;
}
.detaileds-tabel {
  overflow: hidden;
  margin-left: 24px;
  margin-bottom: 27px;
}
.detaileds-tabel div {
  float: left;
  margin-right: 10px;
  color: #577DF4;
  border: 1px solid #577DF4;
  border-radius: 5px;
  padding: 5px 7px 4px 6px;
  font-size: 12px;
}
.detaileds-tabel-span {
  overflow: hidden;
  cursor: pointer;
}
.detaileds-tabel-span span{
  float: left;
  width: 5px;
  height: 5px;
  margin-top: 10px;
  margin-left: 6px;
  background-color: #D8D8D8;
  margin-bottom: 10px;
  border-radius: 2.5px;
}
.detaileds-right {
  float: right;
  overflow: hidden;
  margin-top: 50px;
  margin-right: 24px;
  width: 35%;
  text-align: right;
  font-size: 14px;
  color: #868686;
}
/* 简介 */
.blurb{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 15px;
  background-color: #fff;
}
.blurb-change{
  background-color: #f9f9f9;
  overflow: hidden;
  border-bottom: 3px solid #587CF7;
  width: 1200px;
  margin: 0 auto;
}
.blurb-change-one{
  width: 124px;
  margin-left: 6px;
  height: 49px;
  line-height: 49px;
  float: left;
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin-top: 15px;
  cursor: pointer;
  font-weight: 550;
  text-align: left;
}
.blurb-title{
  overflow: hidden;
}
.blurb-title-left{
  float: left;
  margin-right: 106px;
}
.blurb-title-left div:first-child{
  margin-top: 30px;
  margin-left: 30px;
  height: 168px;
  width: 631px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 38px;
  color: #868686;
  text-align: justify;
  line-height: 24px;
}
.blurb-title-left div:last-child{
  margin-left: 30px;
  padding-bottom: 33px;
  color: #027FFE;
  cursor:pointer;
  font-size: 14px;
}
.blurb-title-img{
  float: left;
  width: 385px;
  height: 213px;
  margin-top: 30px;
}
/* 热招职位 */
.enterpriseDetails-hots{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 24px;
  margin-top: 30px;
}
.enterpriseDetails-hots-title{
  font-size: 18px;
  font-weight: 550;
  margin-left: 6px;
}
.enterpriseDetails-jobs{
  width: 1200px;
  margin: 0 auto;
}
.enterpriseDetails-boxs{
  position: relative;
  display: inline-block;
  background: #fff;
  width: 100%;
  margin-bottom: 20px;
}
.enterpriseDetails-boxs-title{
  border-bottom: 1px dashed #D9D9D9;
  margin: 16px 13px 0 24px;
  cursor:pointer;
}
.enterpriseDetails-boxs-top{
  overflow: hidden;
  width: 860px;
  margin-bottom: 17px;
  height: 25px;
  line-height: 25px;
  padding-top: 17px;
}
.enterpriseDetails-boxs-top div:first-child{
  float: left;
  font-size: 18px;
  font-weight: 550;
  margin-right: 5px;
}
.enterpriseDetails-boxs-top div:last-child{
  float: left;
  font-size: 14px;
}

.enterpriseDetails-boxs-requirement{
  padding-bottom: 20px;
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  width: 860px;
  display: inline-block;
}
.enterpriseDetails-workName,.enterpriseDetails-eduName{
  float: left;
  font-size: 12px;
  color: #ABABAB;
  margin-right: 15px;
}
.enterpriseDetails-boxs-requirement-jobs{
  overflow: hidden;position: absolute;right: 14px;top: 35px;
}
.enterpriseDetails-boxs-requirement-jobs-detail,.enterpriseDetails-boxs-requirement-jobs-details{
  float: left;margin-right: 8px;width: 110px;overflow: hidden;height: 43px;line-height: 45px;border-radius: 5px;border: 1px solid #577DF4;cursor:pointer;text-align: center;vertical-align: middle;
}
.enterpriseDetails-boxs-requirement-jobs-detail div{
  font-size: 14px;
  color: #587CF7;
  display: inline-block;
}
.enterpriseDetails-boxs-requirement-jobs-details div{
  font-size: 14px;
  color: #fff;
  display: inline-block;
}
.enterpriseDetails-boxs-requirement-jobs-details{
  width: 174px;
  margin-right: 0;
  background: #587CF7;
}
.enterpriseDetails-boxs-requirement-jobs-detail img,.enterpriseDetails-boxs-requirement-jobs-details img{
  width: 16px;
  height: 16px;
}
.enterpriseDetails-boxs-requirement-jobs-detail-signup{
  float: left;margin-right: 8px;width: 110px;overflow: hidden;height: 43px;line-height: 45px;border-radius: 5px;border: 1px solid rgb(246, 246, 246);cursor:pointer;text-align: center;vertical-align: middle;
}
.enterpriseDetails-boxs-requirement-jobs-detail-signup div{
  font-size: 14px;
  color: rgb(143, 138, 138);
  display: inline-block;
}
.enterpriseDetails-boxs-requirement-jobs-detail-signup{
  width: 174px;
  margin-right: 0;
  background: rgb(246, 246, 246)
}
.enterpriseDetails-boxs-requirement-jobs-detail-signup img{
  width: 16px;
  height: 16px;
}

.enterpriseDetails-price-item{
  float: left;
  font-size: 18px;
  font-weight: 550;
  color: #FF8C41;
  margin-right: 12px;
}
.enterpriseDetails-boxs-label{
  margin-left: 24px;
  overflow: hidden;
  height: 22px;
  padding-top: 12px;
  padding-bottom: 18px;
}
.enterpriseDetails-boxs-label-welfare{
  float: left;
  width: 64px;
  height: 20px;
  border: 1px solid #027FFE;
  background-color: #F2FAFF;
  text-align: center;
  border-radius: 5px;
  line-height: 22px;
  color: #027FFE;
  font-size: 12px;
  margin-right: 15px;
}
/* 筛选条件 */
.enterpriseDetails-screen{
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  height: 57px;
  margin-bottom: 16px;
}
.enterpriseDetails-screen-box{
  width: 100%;
  height: 100%;
}
.el-dropdown {
  display: inline-block;
  position: relative;
  color: #2E2E2E;
  font-size: 14px;
  height: 26px;
  border-radius: 5px;
  line-height: 26px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #2E2E2E;
  font-size: 12px;
  margin-left: 17px;
  overflow: hidden;
}
.el-icon-arrow-down {
  font-size: 16px;
}
.el-icon--right {
  float: right;
  margin-top: 5px;
  margin-right: 12px;
}
/* 职位推荐 */
.enterpriseDetails-bottom{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.enterpriseDetails-joblist{
  width: 861px;
  /*margin-right: 9px;*/
  margin-bottom: 16px;
  background: #fff;
  position: relative;
}
.cycle {
  width: 385px;
  height: 213px;
  position: relative;
  top: 0;
  left: 0;
  margin: 0 auto;
  z-index: 10;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.content {
  display: flex;
  height: 100%;
  transition: 0.5s ease;
}
.linkmanBoxs{
  line-height: 22px;
  font-size: 16px;
  color: #868686;
  display: flex;
  /*float: right;*/
}
.linkmanBoxs:first-child{
  margin-bottom: 8px;
}
.linkmanBoxs img{
  width: 16px;
  height: 16px;
  margin-top: 3px;
  margin-right: 5px;
  float: left;
}
.linkmanBoxs div{
  float: left;
}
.linkmanBoxs div:first-child{
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseDetails.vue